class Storage {
  getSessionData() {
    let user = {};
    let session = {};
    try {
      user = JSON.parse(localStorage.getItem("user"));
      session = JSON.parse(localStorage.getItem("session"));
    } catch (e) {}

    return {
      user: user || {},
      session: session || {},
    };
  }

  getJoinWebinarId() {
    let joinWebinarId = null;
    joinWebinarId = localStorage.getItem("joinWebinarId");
    return joinWebinarId;
  }

  getJoinGroupId() {
    let joinGroupId = null;
    joinGroupId = localStorage.getItem("joinGroupId");
    return joinGroupId;
  }

  setJoinGroupId(id) {
    localStorage.setItem("joinGroupId", id);
  }

  setJoinWebinarId(id) {
    localStorage.setItem("joinWebinarId", id);
  }

  removeJoinWebinarId() {
    localStorage.removeItem("joinWebinarId");
  }

  removeJoinGroupId() {
    localStorage.removeItem("joinGroupId");
  }

  setAdminSuperToken(token) {
    localStorage.setItem("admin_super_token", token);
  }

  getAdminSuperToken() {
    return localStorage.getItem("admin_super_token");
  }

  setSessionData(user = {}, session = {}) {
    this.purgeSessionData();
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("session", JSON.stringify(session));
  }

  purgeSessionData() {
    localStorage.setItem("user", JSON.stringify({}));
    localStorage.setItem("session", JSON.stringify({}));
    return true;
  }
}

export default new Storage();



// WEBPACK FOOTER //
// ./src/services/storage.js